import {
    companySlug,
    distributionSlug,
    ingredientSlug,
    intermediateProductSlug,
    networkSlug,
    packagingSlug,
    productSlug,
    supplierSlug,
    transformationSlug,
    transportSlug,
} from "./URLHandler";

type Options = {
    url: string;
    options: {
        slug: string;
        newId: number | string;
    }[];
};
export const switchUrl = ({ url, options }: Options): string => {
    let newUrl = url;
    for (const { slug, newId } of options) {
        const parts = newUrl.split("/");
        const slugIndex = parts.indexOf(slug);

        if (slugIndex !== -1 && slugIndex + 1 < parts.length) {
            parts[slugIndex + 1] = String(newId);
            newUrl = parts.join("/");
        }
    }
    return newUrl;
};

type FindOptions = {
    url: string;
    options: {
        slug: string;
    }[];
};
export const isInUrl = ({ url, options }: FindOptions): boolean => {
    const parts = url.split("/");
    for (const { slug } of options) {
        const slugIndex = parts.indexOf(slug);
        if (slugIndex === -1) {
            return false;
        }
    }

    return true;
};

type WhereAmIOptions = {
    url: string;
};

const productValueChainsSlug = "value-chains";

export const whereAmI = (opts: WhereAmIOptions) => {
    const { url } = opts;

    const isHome = url === "/";
    const inProductValueChains = isInUrl({
        url,
        options: [{ slug: productSlug }, { slug: productValueChainsSlug }],
    });
    const inIntermediateProduct = isInUrl({ url, options: [{ slug: intermediateProductSlug }] });
    const inProduct = isInUrl({ url, options: [{ slug: productSlug }] });
    const inIngredients = isInUrl({ url, options: [{ slug: ingredientSlug }] });
    const inSuppliers = isInUrl({ url, options: [{ slug: supplierSlug }] });
    const inPackagings = isInUrl({ url, options: [{ slug: packagingSlug }] });
    const inDistribution = isInUrl({ url, options: [{ slug: distributionSlug }] });
    const inTransport = isInUrl({ url, options: [{ slug: transportSlug }] });
    const inTransformations = isInUrl({ url, options: [{ slug: transformationSlug }] });
    const inNetwork = isInUrl({ url, options: [{ slug: companySlug }, { slug: networkSlug }] });

    const isNotCompany =
        inProduct ||
        inIntermediateProduct ||
        inIngredients ||
        inSuppliers ||
        inPackagings ||
        inDistribution ||
        inTransport ||
        inTransformations ||
        inNetwork;

    const inCompany = !isNotCompany && isInUrl({ url, options: [{ slug: companySlug }] });

    return {
        isHome,
        inProductValueChains,
        inProduct,
        inIntermediateProduct,
        inIngredients,
        inSuppliers,
        inPackagings,
        inDistribution,
        inTransport,
        inTransformations,
        inNetwork,
        inCompany,
    };
};
